import { USBGrid } from '@usb-shield/react-grid/dist/esm';
import PropTypes from 'prop-types';
import React from 'react';
import MainLayout from './mainLayout';
import AsideLayout from './asideLayout';
import CenteredLayout from './centeredLayout';
import classNames from 'classnames';
import FullLayout from './fullLayout';
import '../styles/index.scss'

const Layout = ({ id, children, addClasses, ...otherProps }) => {

  return (
    <USBGrid addClasses={classNames(...addClasses,'usbobp-layout--override-row-gap usbobp-layout--override-tb-padding')} addId={id} {...otherProps}>
      {children}
    </USBGrid>
  );
};
Layout.Main = MainLayout;
Layout.ContentColumns = MainLayout;
Layout.Aside = AsideLayout;
Layout.AsideColumns = AsideLayout;
Layout.Centered = CenteredLayout;
Layout.PaddingColumns = CenteredLayout;
Layout.FullColumns = FullLayout;

Layout.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node.isRequired,
  otherProps: PropTypes.any,
  addClasses: PropTypes.any
};
Layout.defaultProps = {
  id: '',
  otherProps: {},
  addClasses: []
};

export default Layout;
